export class DimensionsModel {
  /**
     *
     * @param width
     * @param height
     * @param depth
     */
  constructor(width = 0, height = 0, depth = 0) {
    this.width = width;
    this.height = height;
    this.depth = depth;
  }
}

export default DimensionsModel;
